import { useState } from 'react';
import { DonViCoSo, KhachHang, KhoHang, Lo, PhieuXuatKho, VatTu, ViTri } from '@/types/schemas';

export interface SearchFieldState {
  khachHang: KhachHang | null;
  vatTu: VatTu | null;
  khoHang: KhoHang | null;
  lo: Lo | null;
  viTri: ViTri | null;
  donViCoSo: DonViCoSo | null;
}

export interface SearchFieldActions {
  setKhachHang: (khachHang: KhachHang | null) => void;
  setVatTu: (vatTu: VatTu | null) => void;
  setKhoHang: (khoHang: KhoHang | null) => void;
  setLo: (lo: Lo | null) => void;
  setViTri: (viTri: ViTri | null) => void;
  setDonViCoSo: (donViCoSo: DonViCoSo | null) => void;

  resetState: () => void;
  updateState: (updates: Partial<SearchFieldState>) => void;
}

export interface UseSearchFieldReturn {
  state: SearchFieldState;
  actions: SearchFieldActions;
}

const initialState: SearchFieldState = {
  khachHang: null,
  vatTu: null,
  khoHang: null,
  lo: null,
  viTri: null,
  donViCoSo: null
};

function transformInitialData(initialData?: PhieuXuatKho | null): Partial<SearchFieldState> {
  if (!initialData) return {};

  return {
    khachHang: initialData.ma_kh_data || null,
    vatTu: initialData.ma_vt_data || null,
    khoHang: initialData.ma_kho_data || null,
    lo: initialData.ma_lo_data || null,
    viTri: initialData.ma_vi_tri_data || null,
    donViCoSo: initialData.ma_unit_data || null
  };
}

export function useSearchField(initialData?: PhieuXuatKho | null): UseSearchFieldReturn {
  const [state, setState] = useState<SearchFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: SearchFieldActions = {
    setKhachHang: (khachHang: KhachHang | null) => {
      setState(prev => ({
        ...prev,
        khachHang
      }));
    },

    setVatTu: (vatTu: VatTu | null) => {
      setState(prev => ({
        ...prev,
        vatTu
      }));
    },

    setKhoHang: (khoHang: KhoHang | null) => {
      setState(prev => ({
        ...prev,
        khoHang
      }));
    },

    setLo: (lo: Lo | null) => {
      setState(prev => ({
        ...prev,
        lo
      }));
    },

    setViTri: (viTri: ViTri | null) => {
      setState(prev => ({
        ...prev,
        viTri
      }));
    },

    setDonViCoSo: (donViCoSo: DonViCoSo | null) => {
      setState(prev => ({
        ...prev,
        donViCoSo
      }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<SearchFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
